import React from "react";
import { FaUserCheck, FaAmbulance, FaBed, FaWheelchair } from "react-icons/fa";

const transitStages = [
  { id: 1, label: "Admitted", icon: FaUserCheck },
  { id: 2, label: "In Transit", icon: FaWheelchair },
  { id: 3, label: "Arrived", icon: FaBed },
];

export default function TransitStatus({ currentStage = 1 }) {
  return (
    <div className="flex items-center justify-center gap-4 my-8">
      {transitStages.map((stage, index) => (
        <React.Fragment key={stage.id}>
          <div className="flex flex-col items-center">
            {/* Icon */}
            <stage.icon
              className={`text-3xl ${
                index + 1 <= currentStage ? "text-green-500" : "text-gray-400"
              }`}
            />
            {/* Label */}
            <p
              className={`mt-2 text-sm font-medium ${
                index + 1 <= currentStage ? "text-gray-800" : "text-gray-500"
              }`}
            >
              {stage.label}
            </p>
          </div>
          {/* Progress Line */}
          {index < transitStages.length - 1 && (
            <div
              className={`w-16 h-1 ${
                index + 1 < currentStage ? "bg-green-500" : "bg-gray-300"
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
